import { InjectableClass } from '@fino/lib-injection';

export class PaymentPartnersController extends InjectableClass {
  constructor(creditorsService, PaymentPartnersSuggestTemplate) {
    'ngInject';
    super({ creditorsService, PaymentPartnersSuggestTemplate });
  }

  $onInit() {
    // Initialize default empty model list
    if (!angular.isArray(this.model)) {
      this.model = [];
    }
  }

  addPaymentPartner(item, list) {
    // Prevent duplicates
    if (this.model.indexOf(item) === -1) {
      this.model.push({ name: item });
    }
  }

  removePaymentPartner(index) {
    this.model.splice(index, 1);
  }

  get canNotBeAdded() {
    return !this.paymentPartner;
  }

  clear() {
    this.paymentPartner = '';
  }

  addPartner() {
    this.addPaymentPartner(this.paymentPartner);
    this.clear();
  }
}
